import React from "react";
import { fetchUserAttributes, getCurrentUser } from "@aws-amplify/auth";
import { ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "store";
import { signOut } from "aws-amplify/auth";

export const PublicRouter = ({ children }: { children: ReactNode }) => {
  const user = useSelector((state: RootState) => state.auth.user);

  if (!user) {
    signOut();
    sessionStorage.clear();
    localStorage.clear();
  }

  return !user ? children : <Navigate to="/view-group" replace />; // Redirect to view-group if authenticated
};
